/*
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2016-2020 Michael Purcaro, Henry Pratt, Jill Moore, Zhiping Weng
 */

export const p_or_q = value => (
    value === -1 ? '--' : value
);



// WEBPACK FOOTER //
// ./src/common/components/render.jsx